export default {
    user(state) {
        return state.user;
    },
    authenticated(state) {
        return !!state.user;
    },
    person(state) {
        if (!state.user) return null;

        return state.user.person;
    },
    hasSubscriptions(state){
        return state.hasSubscriptions;
    },
    updatedEmail: state => state.updatedEmail,
    version: state => state.version,
    updateRequired: state => state.updateRequired
};



// WEBPACK FOOTER //
// ./src/store/getters.js